import ProfissionalAPI from "./../../../servicos/ProfissionalAPI";
import MensagemAPI from "./../../../servicos/MensagemAPI";
import ServicoAPI from "./../../../servicos/ServicoAPI";
import AppAPI from "./../../../servicos/AppAPI";

import { useRef, useContext, useState, useEffect, useMemo } from "react";
import { motion } from "framer-motion";

import { DivMapa } from "../../../componentes/Mapa";
import { BlocoFlutuante } from "../../../componentes/uteis/blocoFlutuante";
import { BtnRedondo } from "../../../componentes/btnRedondo";
import { BtnConectar } from "../../../componentes/BtnConectar";
import { AtivoPill } from "../../../componentes/usuario/AtivoPill";
import CardSaldoHome from "../../../componentes/usuario/CardSaldoHome";
import SaldoHomeBoundary from "../../../componentes/usuario/SaldoHomeBoundary";

import CheckPermission from "../../../servicos/config/CheckPermission.js";

import { MdMyLocation, MdPlaylistAddCheck, MdAddTask, MdAddLocationAlt, MdChat, MdMenu, MdNotifications, MdBlock, MdWorkHistory, MdRoute } from "react-icons/md";

import { ContextoGeral } from "../../../contextos/ContextoGeral";
import { dominioTemMinhaRota, lerMinhaRotaVisivel } from "../../../utils/preferenciaMinhaRota";

import "./mapa.module.css";
import MenuLateral from "../../../componentes/gerais/Menu";
import { useNavigate } from "react-router-dom";
import { configAnim } from "../../../servicos/config/configAnim";
import { Spinner } from "../../../componentes/Spinner";
import { Avatar, Backdrop, Badge, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Popover } from "@mui/material";
import MensagemApp from "../../../servicos/config/MensagemApp";
import { useLayoutEffect } from "react";
import { Balloon } from "./styles";
import useTestChecker from "../../../hooks/general/useTestChecker";
import { Close } from "@mui/icons-material";
import useMessageCount from './../../../componentes/gerais/hook/useContarMensagens.jsx';

import { ChatContext } from "../../../contextos/ContextoChat.jsx";
import { isIOS } from "../../../servicos/config/nativeBridge.js";
import CampanhasNotificacoesMapa from "../campanhas/CampanhasNotificacoesMapa.jsx";

// horasSuspenso/horas: formato HH:MM, valor em MINUTOS (ex: "00:02" = 2 minutos)
function parseHorasSuspensoToMinutes(str) {
	if (!str || typeof str !== "string") return null
	const m = /^(\d{1,2}):(\d{2})$/.exec(str.trim())
	if (!m) return null
	const horas = parseInt(m[1], 10)
	const mins = parseInt(m[2], 10)
	if (Number.isNaN(horas) || Number.isNaN(mins)) return null
	return horas * 60 + mins
}

// Parser robusto para dataFimPunicao (API pode enviar YYYY-MM-DD HH:mm:ss ou DD/MM/YYYY HH:mm:ss)
function parseDataFim(str) {
	if (!str || typeof str !== "string") return null
	const s = str.trim()
	const iso = s.replace(" ", "T")
	let d = new Date(iso)
	if (!Number.isNaN(d.getTime())) return d
	const br = /^(\d{1,2})\/(\d{1,2})\/(\d{4})\s+(\d{1,2}):(\d{2})(?::(\d{2}))?/.exec(s)
	if (br) {
		const [, dia, mes, ano, h, m, seg = "0"] = br
		d = new Date(ano, Number(mes) - 1, Number(dia), Number(h), Number(m), Number(seg))
		if (!Number.isNaN(d.getTime())) return d
	}
	return null
}

export default function Mapa() {
	const navegar = useNavigate();
	const { status } = useContext(ChatContext)

	const refPerfil = useRef();
	const refLocal = useRef();
	const refMenu = useRef();
	const refBuscarPunicao = useRef(0);
	const refJaMostrouTempoPositivo = useRef(false);
	const refInicioPunicao = useRef(null);
	const refServices = useRef();
	const refRota = useRef();
	const refCotation = useRef();
	const refFilaVaga = useRef();
	const refPull = useRef();
	const refMsg = useRef();
	/** Pedido de ficar OL ainda não concluído (permissões/Ajustes): usado para retomar Conectar ao voltar à app. */
	const refRetomarConectarOL = useRef(false);
	/** Evita sobreposição de duas execuções de conectar (toque + retoma automática). */
	const refConectarEmExecucao = useRef(false);
	const conectarRef = useRef(null);
	/** Cópia síncrona de dados.statusOnline para listeners (visibility / hook iOS) sem encerramento obsoleto. */
	const refStatusOnline = useRef(false);

	const [open, setOpen] = useState(false);
	const [tutorial, setTutorial] = useState(false);
	const [popAnchor, setPopAnchor] = useState(null);
	const [localAnchor, setLocalAnchor] = useState(null);
	const [menuAnchor, setMenuAnchor] = useState(null);
	const [servicesAnchor, setServicesAnchor] = useState(null);
	const [rotaAnchor, setRotaAnchor] = useState(null);
	const [cotationAnchor, setCotationAnchor] = useState(null);
	const [filaVagaAnchor, setFilaVagaAnchor] = useState(null);
	const [pullAnchor, setPullAnchor] = useState(null);
	const [msgAnchor, setMsgAnchor] = useState(null);
	const [QTD, setQTD] = useState({});

	const [dialog, setDialog] = useState({
		show: false,
		title: "",
		text: "",
	})

	const [punicao, setPunicao] = useState({
		ativo: false,
		dataFim: null,
		mensagem: "",
		config: null,
	})
	const [dialogPunicao, setDialogPunicao] = useState(false)
	const [tempoRestante, setTempoRestante] = useState("")

	// Extrai exibirIconeBloqueado de arrayConfiguracoes (string com escapes ou objeto)
	const parseExibirIconeBloqueado = (raw) => {
		if (!raw) return "N"
		if (typeof raw === "object" && raw !== null) {
			const v = raw.exibirIconeBloqueado ?? raw.ExibirIconeBloqueado
			return String(v ?? "N").trim().toUpperCase()
		}
		if (typeof raw !== "string") return "N"
		let obj = null
		try {
			obj = JSON.parse(raw)
		} catch {
			try {
				obj = JSON.parse(raw.replace(/\\\\/g, "\\"))
			} catch {
				try {
					obj = JSON.parse(raw.replace(/\\/g, ""))
				} catch {
					// Fallback regex: captura "exibirIconeBloqueado":"S" ou variações com escapes
					return /exibirIconeBloqueado[\s"\\:]*["']?\s*S\s*["']?/i.test(raw) ? "S" : "N"
				}
			}
		}
		for (let i = 0; i < 5 && typeof obj === "string"; i++) {
			try {
				obj = JSON.parse(obj.replace(/\\\\/g, "\\").replace(/\\"/g, '"'))
			} catch {
				try {
					obj = JSON.parse(obj)
				} catch {
					return /exibirIconeBloqueado[\s"\\:]*["']?\s*S\s*["']?/i.test(typeof obj === 'string' ? obj : raw) ? "S" : "N"
				}
			}
		}
		if (obj && typeof obj === "object") {
			const v = obj.exibirIconeBloqueado ?? obj.ExibirIconeBloqueado
			return String(v ?? "N").trim().toUpperCase()
		}
		return /exibirIconeBloqueado[\s"\\:]*["']?\s*S\s*["']?/i.test(raw) ? "S" : "N"
	}

	// S = mostrar botão, N = não mostrar (calculado síncronamente)
	const exibirIconeBloqueado = useMemo(() => {
		if (!punicao.ativo) return false
		const cfg = punicao.config
		if (!cfg) return false
		// Objeto direto: arrayConfiguracoes já é objeto com exibirIconeBloqueado
		const arr = cfg.arrayConfiguracoes
		if (arr && typeof arr === "object") {
			const v = arr.exibirIconeBloqueado ?? arr.ExibirIconeBloqueado
			if (String(v ?? "").trim().toUpperCase() === "S") return true
		}
		// Topo de config
		if (cfg.exibirIconeBloqueado === "S" || cfg.ExibirIconeBloqueado === "S") return true
		// String ou outro formato
		if (arr === undefined || arr === null) return false
		return parseExibirIconeBloqueado(arr) === "S"
	}, [punicao.ativo, punicao.config])

	const [menu, setMenu] = useState(false);
	const [qtdeMensagens, setQtdeMensagens] = useState(<Spinner size="0.1rem" />);

	const [centro, setCentro] = useState([0, 0]);
	const [zoom, setZoom] = useState(3);
	const [endAtivos, setEndAtivos] = useState();

	const { dados, setDados, deslogar, websocket, gestaoVagasModulo } = useContext(ContextoGeral)
	// Ícone da fila vem do módulo já carregado no ContextoGeral (sem rota extra aqui).
	const exibirIconeFilaGestaoVaga = !!gestaoVagasModulo?.info?.exibirIconeFila
	refStatusOnline.current = !!dados?.statusOnline

	useEffect(() => {
		let cancelado = false
		async function checarCidadeEstadoPendente() {
			if (!dados?.idProf || !dados?.token) return
			const retorno = await ProfissionalAPI.buscarDadosAdicionais(dados)
			if (cancelado) return
			const campos = retorno?.dados?.campos
			if (retorno?.resultado && campos && (campos.cidade || campos.estado || campos.cep)) {
				navegar('/app/dadosUsuario', { replace: true, state: { exigirCidadeEstado: true } })
			}
		}
		checarCidadeEstadoPendente()
		return () => { cancelado = true }
	}, [dados?.idProf, dados?.token])

	const isTest = useTestChecker(dados.dominio);

	const [btnConectar, setBtnConectar] = useState({
		texto: <div className="my-2">
			<Spinner />
		</div>,
		textoPill: "",
		disabled: true,
	})

	const handlePuxarServico = () => {
		if (!dados.modulos?.puxaServico || (dados.modulos?.puxaServico && dados.modulos.puxaServico.ativo == "S"))
			if (btnConectar.ativo) navegar("/app/puxarServico");
			else {
				let msgErr = "Favor fique online para prosseguir!";
				if (window.AndroidInterface) window.AndroidInterface.showAndroidVersion(MensagemApp.deslogado);
				else alert(msgErr);
			}
	};

	const fecharDialog = () => setDialog(prev => ({ ...prev, show: false }))
	const mostrarTutorial = () => {
		fecharDialog()
		setTutorial(true)
	}

	const abrirConfig = () => {
		try {
			if (window.AndroidInterface) window.AndroidInterface.showSettingApp()
		} catch (error) { console.error(error) }
	}

	const dispararRetomaConectarSePendente = () => {
		if (!isIOS()) return
		if (!refRetomarConectarOL.current) return
		if (refConectarEmExecucao.current) return
		if (refStatusOnline.current) {
			refRetomarConectarOL.current = false
			return
		}
		const tentar = () => {
			if (!refRetomarConectarOL.current || refConectarEmExecucao.current || refStatusOnline.current) return
			const fn = conectarRef.current
			if (typeof fn === "function") fn(false)
		}
		window.setTimeout(tentar, 450)
		window.setTimeout(tentar, 1100)
	}

	useEffect(() => {
		if (!isIOS()) return
		const onVisibility = () => {
			if (document.visibilityState !== "visible") return
			dispararRetomaConectarSePendente()
		}
		document.addEventListener("visibilitychange", onVisibility)
		return () => document.removeEventListener("visibilitychange", onVisibility)
	}, [])

	useEffect(() => {
		if (!isIOS()) return
		window.__onIosAppBecameActive = () => dispararRetomaConectarSePendente()
		return () => {
			try {
				delete window.__onIosAppBecameActive
			} catch {
				window.__onIosAppBecameActive = undefined
			}
		}
	}, [])

	useEffect(() => {
		if (QTD.servicos > 0) if (!dados?.statusOnline) conectar(true);
	}, [QTD.servicos]);

	useEffect(() => {
		if (dados?.statusOnline) {
			//console.log('status 1 ',dados.statusOnline)	
			/**
			 * VERIFICAR TODAS PERMISSÕES
			 */
			let retorno = testaPermissoes();
			startService();
			//console.log('retorno 1 ',retorno);
		} else {
			//console.log('status 2 ',dados?.statusOnline)
		}
	}, [dados?.statusOnline]);

	async function handleProfLocation() {
		setZoom(20)
		try {
			if (window.AndroidInterface) {
				let localizacao = await JSON.parse(await window.AndroidInterface.getLocation());

				if (localizacao.latitude !== 0) {
					setCentro([localizacao.latitude, localizacao.longitude]);
					return true;
				} else return false
			} else return false
		} catch {
			console.error("não foi possível pegar a localização")
		}
	}

	function startService() {
		try {
			if (window.AndroidInterface)
				window.AndroidInterface.startBackgroundLocation(dados.idProf, dados.token, "enviarLocalizacao")
		} catch {
			console.error("Não possui função para iniciar o serviço de fundo")
		}
	}

	function stopService() {
		try {
			if (!!window.AndroidInterface)
				window.AndroidInterface.stopBackgroundLocation()
		} catch {
			console.error("Não possui função para fechar o serviço de fundo")
		}
	}

	async function testaPermissoes() {
		return await verificaPemissaoAndroid()

	}

	async function verificaPemissaoAndroid() {
		//console.log('aqui status =',dados.status);
		//console.log('aqui status online =',dados.statusOnline);
		if (window.AndroidInterface) {
			// PERMISSÃO DE NOTIFICAÇÃO
			if (!(await CheckPermission.checkNotificationAvailable())) {
				//console.log(' permissao notificacao ');
				window.AndroidInterface.showPermissaoNotification(MensagemApp.msgPermissaoNotificacao);
				return false;
			}

			// VERIFICA OTIMIZAÇÃO DE BATERIA. 
			try {
				if (!(await CheckPermission.checkBatteryOptimization())) {
					//console.log(' permissao bateria ');
					ProfissionalAPI.relatarAntifraude(dados, "OB")

					try {
						if (await window.AndroidInterface.versaoSdkAndroid() <= 25) {
							setDialog({
								show: dados.otimizacaoBateria != "NF",
								title: "ATENÇÃO",
								text: "Para você ficar online deve desativar a otimização de bateria. Acesse as configurações do aparelho para desativar a opção bateria/otimização nas configurações do seu android.",
								block: dados.otimizacaoBateria == "B",
								tutorial: true
							})
						} else {
							setDialog({
								show: dados.otimizacaoBateria != "NF",
								title: "ATENÇÃO",
								text: "Para você ficar online deve desativar a otimização de bateria. Acesse as configurações do aplicativo para desativar a opção bateria/otimização.",
								block: dados.otimizacaoBateria == "B",
								tutorial: false
							})
						}
					} catch (error) {
						console.error(error)
					}
				}
			} catch {
				console.error("Não foi possível checar otimização de bateria, não esta disponivel para esta versao do app")
			}

			// PERMISSÃO DE LOCALIZAÇÃO
			if (!(await CheckPermission.checkLocationAvailable())) {
				//console.log(' permissao localização ');
				window.AndroidInterface.showPermissaoLocalizacao(MensagemApp.msgPermissaoGPS)
				return false
			}

			// PERMISSÃO DE SERVIÇO DE FUNDO
			if (!(await CheckPermission.checkBackgroundLocationAvailable())) {
				//console.log(' permissao serviço de fundo ');
				let quantidadeOS = 0
				if (QTD.servicos > 0) quantidadeOS = QTD.servicos

				window.AndroidInterface.showPemissaoActivityBackgroundLocalizacao(
					dados.idProf,
					dados.token,
					"enviarLocalizacao",
					dados.statusOnline,
					quantidadeOS
				)

				return false
			}

			// LOCALIZAÇÃO ATIVA
			if (!CheckPermission.checkLocationEnabled()) {
				//console.log(' localização ativa ');
				window.AndroidInterface.showHabilitarLocalizacao(MensagemApp.msgHabilitarGPS)
				return false
			}

			// PERMISSÃO DE CAMERA
			if (!CheckPermission.checkCamera()) {
				//console.log(' permissao camera ');
				window.AndroidInterface.showPermissaoCamera(MensagemApp.msgPermissaoCamera)
				return false
			}

			// PERMISSÃO DE ARMAZENAMENTO
			if (!CheckPermission.checkStorage()) {
				//console.log(' permissao armazenamento ');
				window.AndroidInterface.showPermissaoArmazenamento(MensagemApp.msgPermissaoArmazenamento)
				return false
			}
		}

		return true
	}

	const conectar = async (isOnline = false) => {
		if (isIOS()) {
			if (refConectarEmExecucao.current) return
			refConectarEmExecucao.current = true
		}

		let statusPermissao = true
		let mostrarAvisoSemLocal = false
		setBtnConectar({
			...btnConectar,
			texto: (
				<div className="my-2">
					<Spinner />
				</div>
			),
			textoPill: "",
			disabled: true,
		})

		let status = dados.statusOnline ? "OF" : "OL"
		if (isOnline) status = 'OL'

		if (isIOS()) {
			const objetivoOL = status === 'OL'
			if (objetivoOL) refRetomarConectarOL.current = true
			else refRetomarConectarOL.current = false
		}

		let jsonDados = dados

		let local = {
			latitude: 0,
			longitude: 0
		}

		async function ativarLocal(resolve) {
			if (isIOS()) {
				const okPermissao = await verificaPemissaoAndroid()
				if (!okPermissao) {
					statusPermissao = false
					resolve(true)
					return
				}

				let temLocal = await handleProfLocation()
				let rodadas = 0

				const intervalo = setInterval(async () => {
					rodadas += 1

					if (rodadas == 3 && window.AndroidInterface)
						window.AndroidInterface.showAndroidVersion("Recebendo sua localização...")

					if (temLocal) {
						clearInterval(intervalo)
						resolve(true)
					} else {
						temLocal = await handleProfLocation()

						if (rodadas == 10) {
							clearInterval(intervalo)
							statusPermissao = false
							mostrarAvisoSemLocal = true
							resolve(true)
						}
					}
				}, 1200)
			} else {
				if (await verificaPemissaoAndroid()) {
					let temLocal = await handleProfLocation()
					let rodadas = 0

					let intervalo = setInterval(async () => {
						rodadas += 1

						if (rodadas == 3 && window.AndroidInterface)
							window.AndroidInterface.showAndroidVersion("Recebendo sua localização...")

						if (temLocal) {
							clearInterval(intervalo)
							resolve(true)
						} else {
							temLocal = await handleProfLocation()

							if (rodadas == 10) {
								clearInterval(intervalo)
								statusPermissao = false
								resolve(true)
							}
						}
					}, 1200)
				}
			}
		}

		try {
			await new Promise(ativarLocal)

			if (isIOS()) {
				if (statusPermissao) {

					if (window.AndroidInterface && status) {
						local = JSON.parse(await window.AndroidInterface.getLocation());
					}

					let retorno = await ProfissionalAPI.alterarStatus(status, dados, local?.latitude, local?.longitude)

					if (retorno?.resultado) {
						if (status == "OF") {
							setEndAtivos([])
							setDados(jsonDados)
							stopService()
							refRetomarConectarOL.current = false
						} else {
							buscarServicosExecucao(true)
							startService()
							refRetomarConectarOL.current = false
						}
					} else {
						if (window.AndroidInterface)
							window.AndroidInterface.showAndroidVersion(retorno.mensagem)

						if (retorno?.aux == 'usuarioInativo' || retorno?.aux == 'tokenInvalido') {
							await deslogar()
							status = 'OF'
							refRetomarConectarOL.current = false
						} else status = 'OL'

					}
				} else {
					status = 'OF'
					try {
						if (mostrarAvisoSemLocal && window.AndroidInterface)
							window.AndroidInterface.showAndroidVersion("Não foi possível obter sua localização")
					} catch {
						console.error("Você não está no Android")
					}
				}
			} else {
				if (statusPermissao) {

					if (window.AndroidInterface && status) {
						local = JSON.parse(await window.AndroidInterface.getLocation());
					}

					let retorno = await ProfissionalAPI.alterarStatus(status, dados, local?.latitude, local?.longitude)

					if (retorno?.resultado) {
						if (status == "OF") {
							setEndAtivos([])
							setDados(jsonDados)
							stopService()
						} else {
							buscarServicosExecucao(true)
							startService()
						}
					} else {
						if (window.AndroidInterface)
							window.AndroidInterface.showAndroidVersion(retorno.mensagem)

						if (retorno?.aux == 'usuarioInativo' || retorno?.aux == 'tokenInvalido') {
							await deslogar()
							status = 'OF'
						} else status = 'OL'

					}
				} else try {
					window.AndroidInterface.showAndroidVersion("Não foi possível obter sua localização")
				} catch {
					console.error("Você não está no Android")
					status = "OF"
				}
			}

			if (status == 'OL') {
				setDados(prev => ({ ...prev, statusOnline: true }))
				startService()

				setBtnConectar({
					status: true,
					ativo: true,
					cor: 'red',
					variant: 'danger',
					texto: 'Desconectar',
					corPill: 'green',
					textoPill: 'ONLINE'
				})

			} else {
				setDados(prev => ({ ...prev, statusOnline: false }))
				stopService()

				setBtnConectar({
					ativo: false,
					cor: 'green',
					variant: 'success',
					texto: 'Conectar',
					corPill: 'red',
					textoPill: 'OFFLINE'
				})
			}
		} finally {
			if (isIOS()) refConectarEmExecucao.current = false
		}
	}

	if (isIOS()) conectarRef.current = conectar

	async function buscarServicosExecucao() {
		if (dados.statusOnline) {
			let local = { latitude: -19, longitude: -43 }

			if (window.AndroidInterface)
				local = JSON.parse(await window.AndroidInterface.getLocation())

			if (Object.keys(local).length > 0) {
				let retorno = await AppAPI.buscarServicosExecucao(dados, local)

				if (retorno?.resultado) {
					let enderecos = {}

					if (retorno?.dados?.enderecos.length > 0) {
						enderecos = retorno.dados.enderecos.map((endereco) => {
							let cor = "var(--bs-danger)"

							if (endereco["es.saida"] != null)
								cor = "var(--bs-success)"
							else if (endereco?.["es.chegada"] != null)
								cor = "var(--bs-warning)"

							if (endereco["corPontoMapa"])
								cor = endereco["corPontoMapa"]

							return {
								idServico: endereco["es.idServico"],
								id: endereco["e.id"],
								la: endereco["e.la"],
								lo: endereco["e.lo"],
								end: endereco["e.rua"],
								cor: cor,
							}
						})
					}

					setEndAtivos(enderecos);
				} else {
					if (retorno?.aux == "usuarioInativo" || retorno?.aux == "tokenInvalido")
						deslogar()
				}
			}
		}
	}

	async function buscarSaldo() {
		if (!dados.hasOwnProperty("saldo")) {
			let retornoSaldo = await ProfissionalAPI.buscarSaldo(dados)

			let jsonDados = dados

			if (retornoSaldo?.resultado)
				setDados((prev) => ({ ...prev, saldo: retornoSaldo.dados.saldo }))
			else {
				if (retornoSaldo?.aux == "usuarioInativo" || retornoSaldo?.aux == "tokenInvalido")
					deslogar()

				jsonDados.saldo = 0.0
				setDados(jsonDados)
			}
		}
	}

	async function buscarQtdMensagemNaoLida() {
		let retornoMensagem = await MensagemAPI.qtdMensagensNaoLida(dados);
		if (retornoMensagem?.resultado)
			setQtdeMensagens(retornoMensagem.dados.qtdeMensagens);
		else {
			if (retornoMensagem?.aux == "usuarioInativo" || retornoMensagem?.aux == "tokenInvalido")
				deslogar()

			setQtdeMensagens(0);
		}
	}

	async function buscarQtdCotacaoServico() {
		let retorno = await ServicoAPI.qtdServico(dados)

			if (retorno?.resultado) {
			setQTD(p => ({
				...p,
				cotacoes: retorno.dados.qtdeCotacoes,
				servicos: retorno.dados.qtdeServicos,
				puxar: retorno.dados.qtdPuxarServico
			}))

			if (retorno.dados.statusProf == "OL") {
				handleProfLocation()
				setDados(prev => ({ ...prev, statusOnline: true }))

				setBtnConectar({
					status: true,
					ativo: true,
					cor: 'red',
					variant: 'danger',
					texto: 'Desconectar',
					corPill: 'green',
					textoPill: 'ONLINE'
				})
			} else {
				setDados(prev => ({ ...prev, statusOnline: false }))

				setBtnConectar({
					ativo: false,
					cor: 'green',
					variant: 'success',
					texto: 'Conectar',
					corPill: 'red',
					textoPill: 'OFFLINE'
				})
			}
		} else {
			if (retorno?.aux == "usuarioInativo" || retorno?.aux == "tokenInvalido")
				deslogar()

			setQTD(p => ({
				...p,
				cotacoes: 0,
				servicos: 0,
				puxar: 0
			}))
		}
	}

	useEffect(() => {
		buscarSaldo()
		buscarQtdMensagemNaoLida()
		buscarQtdCotacaoServico()
		buscarServicosExecucao()

		async function buscarPunicao() {
			if (!dados?.idProf) return
			const gen = refBuscarPunicao.current + 1
			refBuscarPunicao.current = gen
			const retorno = await ProfissionalAPI.buscarAtivo(dados)
			if (gen !== refBuscarPunicao.current) return // ignorar resposta obsoleta
			if (!retorno?.resultado) return
			const d = retorno.dados
			const rawStatus = d?.status
			const statusAtivo = (typeof rawStatus === "string" ? rawStatus : rawStatus?.ativo)?.toString().toUpperCase()
			if (statusAtivo === "P" || statusAtivo === "U") {
				const configCancelamento = d?.configCancelamento || null
				if (process.env.NODE_ENV === "development" && configCancelamento) {
					console.log("[buscarPunicao] configCancelamento recebido:", configCancelamento)
				}
				const cfg = configCancelamento?.arrayConfiguracoes || configCancelamento
				const horasStr = cfg?.horasSuspenso ?? configCancelamento?.horas
				const minutos = parseHorasSuspensoToMinutes(horasStr)

				let dataFim = d?.dataFimPunicao || null
				// Se dataFimPunicao existe mas está no passado (backend pode ter usado segundos em vez de minutos), tratar como ausente
				const parsedFim = dataFim ? parseDataFim(dataFim) : null
				if (parsedFim && parsedFim.getTime() <= Date.now()) dataFim = null

				// Fallback 1: dataInicioPunicao + horasSuspenso (em minutos, formato HH:MM)
				if (!dataFim && d?.dataInicioPunicao && minutos != null && minutos > 0) {
					const inicio = parseDataFim(d.dataInicioPunicao)
					if (inicio) {
						const fim = new Date(inicio.getTime() + minutos * 60 * 1000)
						const pad = (n) => String(n).padStart(2, "0")
						dataFim = `${fim.getFullYear()}-${pad(fim.getMonth() + 1)}-${pad(fim.getDate())} ${pad(fim.getHours())}:${pad(fim.getMinutes())}:${pad(fim.getSeconds())}`
					}
				}
				// Fallback 2: momento em que recebemos a punição + horasSuspenso (API não envia datas)
				if (!dataFim && minutos != null && minutos > 0) {
					if (!refInicioPunicao.current) refInicioPunicao.current = Date.now()
					const fim = new Date(refInicioPunicao.current + minutos * 60 * 1000)
					const pad = (n) => String(n).padStart(2, "0")
					dataFim = `${fim.getFullYear()}-${pad(fim.getMonth() + 1)}-${pad(fim.getDate())} ${pad(fim.getHours())}:${pad(fim.getMinutes())}:${pad(fim.getSeconds())}`
				}
				setPunicao({
					ativo: true,
					dataFim,
					mensagem: d?.mensagemBloqueio || "",
					config: configCancelamento,
				})
			} else {
				refInicioPunicao.current = null
				setPunicao((p) => ({ ...p, ativo: false }))
			}
		}
		buscarPunicao()
	}, [dados?.idProf])

	useEffect(() => {
		if (!punicao.ativo || !punicao.dataFim) {
			setTempoRestante("")
			refJaMostrouTempoPositivo.current = false
			return
		}
		refJaMostrouTempoPositivo.current = false
		function atualizarTempo() {
			const fim = parseDataFim(punicao.dataFim)
			if (!fim) {
				setTempoRestante("")
				if (process.env.NODE_ENV === "development") {
					console.warn("[punicao] dataFim inválida ou formato não suportado:", punicao.dataFim)
				}
				return
			}
			const agora = new Date()
			const ms = fim - agora
			if (ms <= 0) {
				setTempoRestante("Expirado")
				if (refJaMostrouTempoPositivo.current) {
					setPunicao((p) => ({ ...p, ativo: false }))
				}
				return
			}
			refJaMostrouTempoPositivo.current = true
			const h = Math.floor(ms / 3600000)
			const m = Math.floor((ms % 3600000) / 60000)
			const s = Math.floor((ms % 60000) / 1000)
			setTempoRestante(`${h}h ${m}m ${s}s`)
		}
		atualizarTempo()
		const id = setInterval(atualizarTempo, 1000)
		return () => clearInterval(id)
	}, [punicao.ativo, punicao.dataFim])

	useLayoutEffect(() => {
		if (refPerfil && refLocal && refMenu && refServices && refCotation && refPull && refMsg) {
			setTimeout(() => {
				if (isTest && dados.tutoriais.mapa) setOpen(true)
			}, 1500)

			setPopAnchor(refPerfil)
			setLocalAnchor(refLocal)
			setMenuAnchor(refMenu)
			setServicesAnchor(refServices)
			setRotaAnchor(refRota)
			setCotationAnchor(refCotation)
			setPullAnchor(refPull)
			setMsgAnchor(refMsg)
			if (refFilaVaga) {
				setFilaVagaAnchor(refFilaVaga)
			}
		}
	}, [])

	useEffect(() => {
		if (open)
			setTimeout(async () => {
				setOpen(false)

				let json = dados
				json.tutoriais.mapa = false
				setDados(json)
			}, 2000)
	}, [open])

	useEffect(() => {
		if (exibirIconeFilaGestaoVaga) {
			setFilaVagaAnchor(refFilaVaga)
		} else {
			setFilaVagaAnchor(null)
		}
	}, [exibirIconeFilaGestaoVaga])

	const { dadosNotificacoes } = useMessageCount(true, location);
	const [mostrarNotificacoes, setMostrarNotificacoes] = useState('none');
	const [notifCentral, setNotifCentral] = useState(0);

	// Calcula a quantidade de mensagens da sala 'Central' uma vez
	useEffect(() => {

		const chaveSala = `P${dados.idProf}`

		if (dadosNotificacoes?.salas) {

			setNotifCentral(dadosNotificacoes?.salas[chaveSala]);
		}

	}, [dadosNotificacoes]);


	return <motion.div
		initial={configAnim.initial}
		animate={configAnim.animate}
		exit={configAnim.exit}
		transition={configAnim.transition}
	>
		<DivMapa zoom={zoom} center={centro} setCenter={setCentro} enderecos={endAtivos}>
			<div className="v80">
			<BlocoFlutuante
					top="calc(0px - var(--app-vh))"
					left="0pt"
					right="0pt"
					style={{
						width: '100%',
						maxWidth: '100%',
						paddingTop: 'calc(env(safe-area-inset-top, 0px) + 14px)',
						pointerEvents: 'none',
						overflow: 'visible',
						boxSizing: 'border-box',
					}}
				>
					<div
						style={{
							display: 'flex',
							flexDirection: 'column',
							gap: '8px',
							width: '100%',
							maxWidth: '100%',
							boxSizing: 'border-box',
							padding: '4px 6px 0',
							overflow: 'visible',
						}}
					>
						{/* Header: [Avatar] ........ [saldo][ONLINE] */}
						<div
							style={{
								display: 'flex',
								flexDirection: 'row',
								alignItems: 'center',
								justifyContent: 'space-between',
								gap: '6px',
								width: '100%',
								maxWidth: '100%',
								minHeight: 48,
								boxSizing: 'border-box',
								pointerEvents: 'auto',
								overflow: 'visible',
							}}
						>
							<div
								ref={refPerfil}
								style={{
									flexShrink: 0,
									display: 'flex',
									alignItems: 'center',
									justifyContent: 'center',
									position: 'relative',
									zIndex: 3,
								}}
							>
								<BtnRedondo
									style={{ margin: 0 }}
									onClick={() => {
										navegar("/app/perfil");
									}}
									pura
								>
									<Badge badgeContent={dados.foto == "" ? "!" : null} color="error">
										<Avatar
											src={dados.foto}
											sx={{
												margin: 0,
												width: 48,
												height: 48,
											}}
										/>
									</Badge>
								</BtnRedondo>
							</div>
							<div
								style={{
									display: 'flex',
									alignItems: 'center',
									justifyContent: 'flex-end',
									flexWrap: 'nowrap',
									gap: '5px',
									flexShrink: 1,
									minWidth: 0,
									position: 'relative',
									zIndex: 1,
									overflow: 'visible',
									boxSizing: 'border-box',
								}}
							>
								<SaldoHomeBoundary>
									<CardSaldoHome />
								</SaldoHomeBoundary>
								<AtivoPill texto={btnConectar.textoPill} cor={btnConectar.corPill} />
							</div>
						</div>
						<Popover
							id="teste"
							open={open}
							anchorEl={popAnchor?.current}
							anchorOrigin={{
								vertical: "center",
								horizontal: "right",
							}}
							transformOrigin={{
								vertical: "center",
								horizontal: "left",
							}}
						>
							<Balloon>Perfil</Balloon>
						</Popover>
					</div>
				</BlocoFlutuante>

				<BlocoFlutuante bottom="70pt" left="0pt">
					<div ref={refLocal}>
						<BtnRedondo
							collapse={btnConectar.ativo}
							onClick={handleProfLocation}
						>
							<MdMyLocation />
						</BtnRedondo>
					</div>
					{btnConectar.ativo && (
						<Popover
							id="location"
							open={open}
							anchorEl={localAnchor?.current}
							onClose={() => {
								setOpen(false);
								setPopAnchor(null);
							}}
							anchorOrigin={{
								vertical: "center",
								horizontal: "right",
							}}
							transformOrigin={{
								vertical: "center",
								horizontal: "left",
							}}
						>
							<Balloon>Ver sua localização</Balloon>
						</Popover>
					)}
				</BlocoFlutuante>

				<BlocoFlutuante bottom="70pt" right="0pt">
					<motion.div className="mapa-acoes-flutuantes">
						{punicao.ativo && exibirIconeBloqueado && (
							<div
								onClick={() => setDialogPunicao(true)}
								style={{
									display: 'inline-flex',
									alignItems: 'center',
									justifyContent: 'center',
									width: '54px',
									height: '54px',
									borderRadius: '50%',
									backgroundColor: '#d32f2f',
									color: 'white',
									margin: '0.5rem',
									boxShadow: '0px 2px 7px 2px #00000033',
									cursor: 'pointer',
								}}
							>
								<MdBlock style={{ fontSize: '2rem' }} />
							</div>
						)}

						{exibirIconeFilaGestaoVaga ? (
							<>
								<Popover
									id="filaVaga"
									open={open && Boolean(filaVagaAnchor?.current)}
									anchorEl={filaVagaAnchor?.current}
									onClose={() => {
										setOpen(false);
										setPopAnchor(null);
									}}
									anchorOrigin={{
										vertical: "top",
										horizontal: "center",
									}}
									transformOrigin={{
										vertical: "bottom",
										horizontal: "center",
									}}
								>
									<Balloon>Fila de hoje</Balloon>
								</Popover>
								<div
									ref={refFilaVaga}
									onClick={() => {
										navegar("/app/gestaoVaga?entrada=fab");
									}}
								>
									<BtnRedondo collapse>
										<MdWorkHistory />
									</BtnRedondo>
								</div>
							</>
						) : null}

						{(dominioTemMinhaRota(dados.dominio) && lerMinhaRotaVisivel(dados.idProf) && dados.statusOnline && ((endAtivos && endAtivos.length > 0) || QTD.servicos > 0)) ? (
							<>
								<Popover
									id="minhaRota"
									open={open && Boolean(rotaAnchor?.current)}
									anchorEl={rotaAnchor?.current}
									onClose={() => {
										setOpen(false);
										setPopAnchor(null);
									}}
									anchorOrigin={{
										vertical: "top",
										horizontal: "center",
									}}
									transformOrigin={{
										vertical: "bottom",
										horizontal: "center",
									}}
								>
									<Balloon>Minha rota</Balloon>
								</Popover>
								<div
									ref={refRota}
									onClick={() => {
										navegar("/app/rotaServicos");
									}}
								>
									<BtnRedondo
										badge={endAtivos?.length || QTD.servicos}
										collapse
										style={{ backgroundColor: "var(--primaria)", color: "#fff" }}
									>
										<MdRoute />
									</BtnRedondo>
								</div>
							</>
						) : null}

						<Popover
							id="services"
							open={open && Boolean(servicesAnchor?.current)}
							anchorEl={servicesAnchor?.current}
							onClose={() => {
								setOpen(false);
								setPopAnchor(null);
							}}
							anchorOrigin={{
								vertical: "top",
								horizontal: "center",
							}}
							transformOrigin={{
								vertical: "bottom",
								horizontal: "center",
							}}
						>
							<Balloon>Serviços</Balloon>
						</Popover>

						<div
							ref={refServices}
							onClick={() => {
								navegar("/app/servicos");
							}}
						>
							<BtnRedondo badge={QTD.servicos} collapse>
								<MdPlaylistAddCheck />
							</BtnRedondo>
						</div>

						<Popover
							id="cotation"
							open={open && Boolean(cotationAnchor?.current)}
							anchorEl={cotationAnchor?.current}
							onClose={() => {
								setOpen(false);
								setPopAnchor(null);
							}}
							anchorOrigin={{
								vertical: "top",
								horizontal: "center",
							}}
							transformOrigin={{
								vertical: "bottom",
								horizontal: "center",
							}}
						>
							<Balloon>Cotações</Balloon>
						</Popover>
						<div
							ref={refCotation}
							onClick={() => {
								navegar("/app/cotacoes");
							}}
						>
							<BtnRedondo badge={QTD.cotacoes} collapse>
								<MdAddTask />
							</BtnRedondo>
						</div>
						<div ref={refPull} onClick={handlePuxarServico}>
							<BtnRedondo
								badge={QTD.puxar}
								collapse={
									btnConectar.ativo &&
									(!dados.modulos?.puxaServico ||
										(dados.modulos?.puxaServico && dados.modulos.puxaServico.ativo == "S"))
								}
							>
								<MdAddLocationAlt />
							</BtnRedondo>
						</div>

						{btnConectar.ativo &&
							(!dados.modulos?.puxaServico ||
								(dados.modulos?.puxaServico && dados.modulos.puxaServico.ativo == "S")) && (
								<Popover
									id="pull"
									open={open}
									anchorEl={pullAnchor?.current}
									onClose={() => {
										setOpen(false);
										setPopAnchor(null);
									}}
									anchorOrigin={{
										vertical: "center",
										horizontal: "left",
									}}
									transformOrigin={{
										vertical: "center",
										horizontal: "right",
									}}
								>
									<Balloon>Puxar serviços</Balloon>
								</Popover>
							)}

						<div
							style={{
								position: 'fixed',
								bottom: '35vh', // distância do rodapé
								right: '6px', // distância da direita
								zIndex: 1000,  // para garantir que o botão fique sobre outros elementos
							}}
						>
							{dadosNotificacoes?.total > 0 && (
								<span
									style={{
										marginLeft: '-7px',  // Espaço entre o texto e o círculo
										backgroundColor: 'rgb(255 0 0)',
										borderRadius: '50%',
										width: '28px',
										height: '28px',
										display: 'inline-flex',
										justifyContent: 'center',
										alignItems: 'center',
										color: 'white',
										fontSize: '14px',
										fontWeight: 'bold',
										bottom: '38px',
										left: '47px',
										position: 'absolute',
									}}
								>
									{dadosNotificacoes?.total}
								</span>
							)}
						</div>

					</motion.div>
				</BlocoFlutuante>
				<BlocoFlutuante bottom="0pt">
					<div className="rodapeMapa">
						<div className="relative">
							<div ref={refMsg}>
								{status == 0
									? <Spinner />
									: <>
										{dados?.chatConfig?.status == "S"
											? <Badge color="error" badgeContent={qtdeMensagens}>
												<MdNotifications onClick={() => {
													navegar("/app/mensagens");
												}} />
											</Badge>
											: <Badge color="error" badgeContent={qtdeMensagens}>
												<MdChat onClick={() => {
													navegar("/app/mensagens");
												}} />
											</Badge>}
									</>}
							</div>

							<Popover
								id="pull"
								open={open}
								anchorEl={msgAnchor?.current}
								onClose={() => {
									setOpen(false);
									setPopAnchor(null);
								}}
								anchorOrigin={{
									vertical: "top",
									horizontal: "center",
								}}
								transformOrigin={{
									vertical: "bottom",
									horizontal: "center",
								}}
							>
								<Balloon>Notificações</Balloon>
							</Popover>
						</div>
						<div id="blocoBtnConectar" onClick={() => {
                            if (isIOS() && window.AndroidInterface?.clearBackgroundSkip) window.AndroidInterface.clearBackgroundSkip()
                            conectar()
                        }}> 
							<BtnConectar {...btnConectar} />
						</div>
						<div>
							<div ref={refMenu}>
								<MdMenu
									onClick={() => {
										setMenu(true);
									}}
								/>
							</div>
							<Popover
								id="pull"
								open={open}
								anchorEl={menuAnchor?.current}
								onClose={() => {
									setOpen(false);
									setPopAnchor(null);
								}}
								anchorOrigin={{
									vertical: "top",
									horizontal: "center",
								}}
								transformOrigin={{
									vertical: "bottom",
									horizontal: "center",
								}}
							>
								<Balloon>Menu</Balloon>
							</Popover>
						</div>
					</div>
				</BlocoFlutuante>
			</div>
			<MenuLateral show={menu} setShow={setMenu} ativo="0" />
		</DivMapa >
		<Dialog open={dialog.show}>
			<DialogTitle className="text-center">{dialog.title}</DialogTitle>
			<DialogContentText className="px-3">{dialog.text}</DialogContentText>
			<DialogActions>
				<Button
					onClick={
						dialog.tutorial
							? mostrarTutorial
							: abrirConfig
					}
				>
					{dialog.tutorial
						? "Tutorial"
						: "Acessar"}
				</Button>
				{!dialog.block && <Button onClick={fecharDialog}>
					OK
				</Button>}
			</DialogActions>
		</Dialog>
		<Dialog open={dialogPunicao} onClose={() => setDialogPunicao(false)}>
			<DialogTitle>Acesso bloqueado</DialogTitle>
			<DialogContent sx={{ px: 2, pb: 1 }}>
				{punicao.ativo && (
					<p style={{ margin: "0 0 1rem 0", fontSize: "1.1rem" }}>
						{tempoRestante === "Expirado" ? (
							<>Você já está disponível.</>
						) : tempoRestante ? (
							<>Disponível em: <strong>{tempoRestante}</strong></>
						) : (
							<>Carregando tempo restante...</>
						)}
					</p>
				)}
				<p style={{ margin: 0 }}>
					{punicao.mensagem || "Você cancelou serviços após o aceite acima do limite permitido."}
				</p>
			</DialogContent>
			<DialogActions>
				<Button onClick={() => setDialogPunicao(false)}>Fechar</Button>
			</DialogActions>
		</Dialog>
		<Backdrop
			sx={{ zIndex: (theme) => theme.zIndex.drawer + 1, backdropFilter: "blur(5px)" }}
			open={tutorial}
			onClick={() => {
				setDialog(prev => ({ ...prev, show: true }))
				setTutorial(false)
			}}
		>
			<div className="text-white p-3 small">
				<div className="flex justify-end mb-3">
					<Close style={{ fontSize: '2.5rem' }} />
				</div>
				<p>
					Para desativar a otimização de bateria no seu celular acesse as configurações do Android.
				</p>
				<p>
					Em seguida procure pela opção <b>bateria</b> ou similar.
				</p>
				<p>
					Procure pela opção <b>Otimização de bateria</b>, que geralmente é encontrada no canto superior direito.
				</p>
				<p>
					Uma lista de aplicativos deverá aparecer, verifique se a lista está marcada com a opção <b>Todos os apps</b>.
				</p>
				<p>
					Procure por este aplicativo e o selecione, escolha a opção <b>Não otimizar</b> e selecione <b>concluído</b>.
				</p>
				<p>
					Seguindo estes passos você poderá retornar para esta tela novamente.
				</p>
				<div>
					{/* <Button variant="contained">
						fechar
					</Button> */}
				</div>
			</div>
		</Backdrop>
		<CampanhasNotificacoesMapa dados={dados} />
	</motion.div >
}